import {
    GetAssessmentStudentsList,
    DeleteAssessmentStudents,
    GetAssessmentReport,
    ChangeAssessmentStatus,
    ApplyAssessment,
    SaveAnswers,
    GetAnswers,
    SaveComments,
    GetComments,
    FinishAssessment,
} from '@src/services/assessment-students'
import { getSavedState } from '@src/utils/localStorage'
import Vue from 'vue'

export const state = {
    assessmentStudentsList: [],
    assessmentResult: {},
    applicationStudents: [],
    assessmentApplication: {},
    currentQuestion: {},
    currentItem: {},
    autoSkip: true,
}

export const getters = {
    totalList(state) {
        return state.assessmentStudentsList.data
            ? state.assessmentStudentsList.data.totalItemCount
            : 0
    },
    assessmentQuestions(state) {
        if (state.assessmentApplication.assessment) {
            return state.assessmentApplication.assessment.questions
        }
        return {}
    },
    allAssessmentQuestionsIds(state) {
        if (state.assessmentApplication.assessmentQuestionItemsObjectArray) {
            return state.assessmentApplication
                .assessmentQuestionItemsObjectArray
        }
        return {}
    },
    allAssessmentQuestionsItems() {
        if (state.assessmentApplication.assessment) {
            const questionItems = []
            state.assessmentApplication.assessment.questions.forEach(
                ({ questionsItems }) => {
                    questionsItems.forEach((items) => {
                        questionItems.push(items)
                    })
                }
            )
            return questionItems
        }
        return []
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.assessmentStudentsList = newList
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((assessmentStudents) => {
            state.assessmentStudentsList.data.items.push(assessmentStudents)
        })
    },
    SET_STATUS(state, assessmentStudents) {
        state.assessmentStudentsList.data.items.find(({ publicId }) => {
            return publicId === assessmentStudents.publicId
        }).status = assessmentStudents.status
    },
    SET_ASSESSMENT_REPORT(state, newAssessment) {
        state.assessmentResult = newAssessment
    },
    REMOVE_ASSESSMENT_REPORT(state) {
        state.assessmentResult = {}
    },
    SET_STUDENTS_ON_APPLICATION(state, newList) {
        state.applicationStudents = newList
        Vue.set(state, 'applicationStudents', [...newList])
    },
    SET_ASSESSMENT_APPLICATION(state, assessmentApplication) {
        state.assessmentApplication = assessmentApplication
    },
    SET_ANSWER(state, student) {
        state.applicationStudents[student.indexStudent].answer = student.answer
        const newList = state.applicationStudents
        Vue.set(state, 'applicationStudents', [...newList])
    },
    SET_COMMENT(state, student) {
        state.applicationStudents[student.indexStudent].hasAssessmentComments =
            student.answer
        if (student.answer !== 'yes') {
            state.applicationStudents[student.indexStudent].comments = ''
        }
        const newList = state.applicationStudents
        Vue.set(state, 'applicationStudents', [...newList])
    },
    SET_CURRENT_QUESTION(state, newQuestion) {
        state.currentQuestion = newQuestion
    },
    SET_CURRENT_ITEM(state, newItem) {
        state.currentItem = newItem
    },
    SET_AUTO_SKIP(state, autoSkip) {
        state.autoSkip = autoSkip
    },
    SET_STUDENTS_COMMENTS(state, comments) {
        state.applicationStudents.forEach((student) => {
            comments.forEach((comment) => {
                if (
                    student.assessmentApplicationPublicId ===
                    comment.assessmentApplicationPublicId
                ) {
                    student.comments = comment.comments
                    // eslint-disable-next-line no-prototype-builtins
                    if (comment.hasOwnProperty('hasComment')) {
                        student.hasAssessmentComments = comment.hasComment
                            ? 'yes'
                            : 'no'
                    }
                }
            })
        })
        Vue.set(state, 'applicationStudents', [...state.applicationStudents])
    },
    SET_STEP_BROWSABLE(state, step) {
        const stepIndex = state.assessmentApplication.assessmentQuestionItemsObjectArray.findIndex(
            ({ questionItemPublicId }) => questionItemPublicId === step
        )
        state.assessmentApplication.assessmentQuestionItemsObjectArray[
            stepIndex
        ].browsable = true
    },
    PAUSE_STUDENT(state, index) {
        state.applicationStudents.splice(index, 1)
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetAssessmentStudentsList(
            locationPublicId,
            parameters
        )
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
    },
    async nextPage({ commit }, currentPage) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetAssessmentStudentsList(
            locationPublicId,
            currentPage
        )
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
    async deleteAssessmentStudents({ dispatch }, assessmentId) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await DeleteAssessmentStudents(
            locationPublicId,
            assessmentId
        )
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async getAssessmentResultInfo({ commit }, assessmentResultId) {
        const resp = await GetAssessmentReport(assessmentResultId)
        if (resp && resp.status === 200) {
            commit('SET_ASSESSMENT_REPORT', resp.data.data)
        }
        return resp
    },
    removeAssessmentResultInfo({ commit }) {
        commit('REMOVE_ASSESSMENT_REPORT')
    },
    async changeAssessmentStatus({ _ }, assessmentPublicId) {
        const resp = await ChangeAssessmentStatus(assessmentPublicId)
        return resp
    },
    async assessmentApplicationRequest({ _ }, studentsPublicId) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await ApplyAssessment({
            studentsId: studentsPublicId,
            locationPublicId,
        })
        return resp
    },
    setStudentsOnApplication({ state, commit }, appStudents) {
        // se houver respostas antigas, colocá-las em seu respectivo aluno
        const { students, nextAnswers } = appStudents
        // -- > ATENÇÃO: Param nextAnswer para quando já foi enviado alguma resposta nessa avaliação
        const assessmentAnswers =
            nextAnswers || state.assessmentApplication.studentsAnswers
        const studentsFeedback = students.map(
            ({ applicationStatus, level, name, publicId, conceptScore }) => {
                const studentAnswer = assessmentAnswers.find(
                    ({ studentPublicId }) => publicId === studentPublicId
                )
                return {
                    name,
                    level,
                    publicId,
                    applicationStatus,
                    conceptScore: studentAnswer
                        ? studentAnswer.conceptScore
                        : 0,
                    answer: !studentAnswer
                        ? undefined
                        : studentAnswer.answerBool !== null &&
                          studentAnswer.answerBool !== undefined
                        ? studentAnswer.answerBool
                            ? 'yes'
                            : 'no'
                        : undefined,
                    assessmentPoints: studentAnswer
                        ? {
                              current:
                                  studentAnswer.assessmentAccomplishedItems,
                              max: studentAnswer.assessmentMaxItems,
                          }
                        : {
                              current: 0,
                              max:
                                  state.assessmentApplication.assessment
                                      .assessmentMaxItems,
                          },
                    assessmentApplicationPublicId: studentAnswer
                        ? studentAnswer.assessmentApplicationPublicId
                        : '',
                }
            }
        )
        commit('SET_STUDENTS_ON_APPLICATION', studentsFeedback)
    },
    setAssessmentApplication({ commit }, assessment) {
        commit('SET_ASSESSMENT_APPLICATION', assessment)
    },
    setAssessmentAnswer({ state, commit }, studentAnswer) {
        const { answer, studentId } = studentAnswer
        const indexStudent = state.applicationStudents.findIndex(
            ({ publicId }) => publicId === studentId
        )
        commit('SET_ANSWER', {
            indexStudent,
            answer,
        })
    },
    setStudentHasComments({ state, commit }, studentAnswer) {
        const { answer, studentId } = studentAnswer
        const indexStudent = state.applicationStudents.findIndex(
            ({ publicId }) => publicId === studentId
        )
        commit('SET_COMMENT', {
            indexStudent,
            answer,
        })
    },
    setCurrentQuestionAndItem({ commit }, assessmentQuestion) {
        const { question, item } = assessmentQuestion
        // se não houver mais perguntas, setar um objeto vazio
        commit('SET_CURRENT_QUESTION', question || {})
        commit('SET_CURRENT_ITEM', item || {})
    },
    async saveAnswers({ commit, dispatch }, { students, answers }) {
        const resp = await SaveAnswers(answers)
        if (resp && resp.status === 200) {
            const nextAnswers = resp.data.data.studentsAnswers
            const studentsAnswers = {
                students,
                nextAnswers: nextAnswers,
            }
            commit('SET_AUTO_SKIP', resp.data.data.autoSkip)
            dispatch('setStudentsOnApplication', studentsAnswers)
        }
        return resp
    },
    async getAnswers({ commit, dispatch }, { students, answers }) {
        const resp = await GetAnswers(answers)
        if (resp && resp.status === 200) {
            const nextAnswers = resp.data.data.studentsAnswers
            const studentsAnswers = {
                students,
                nextAnswers: nextAnswers,
            }
            commit('SET_AUTO_SKIP', false)
            dispatch('setStudentsOnApplication', studentsAnswers)
        }
        return resp
    },

    async saveComments({ _ }, studentsComments) {
        const request = {
            assessmentApplicationComments: studentsComments,
        }
        const resp = await SaveComments(request)
        return resp
    },
    async requestStudentsComments({ commit }, assessmentApplicationIds) {
        const resp = await GetComments(assessmentApplicationIds)
        commit(
            'SET_STUDENTS_COMMENTS',
            resp.data.data.assessmentApplicationComments
        )
        return resp
    },
    saveCommentOnTable({ commit }, comments) {
        commit('SET_STUDENTS_COMMENTS', comments)
    },
    async requestFinishAssessment({ _ }, studentAssessment) {
        const request = {
            publicIds: studentAssessment.studentsIds,
            assessmentPublicId: studentAssessment.assessmentPublicId,
        }
        const resp = await FinishAssessment(request)
        return resp
    },
    setStepBrowsable({ commit }, currentItemId) {
        commit('SET_STEP_BROWSABLE', currentItemId)
    },
    pauseStudent({ commit }, dataIndex) {
        commit('PAUSE_STUDENT', dataIndex)
    },
}
